import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center min-h-[400px]"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center min-h-[400px]"
}
const _hoisted_4 = { class: "text-center bg-white rounded-xl shadow-lg p-8" }
const _hoisted_5 = { class: "text-gray-600 mb-4" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "mb-8" }
const _hoisted_8 = { class: "text-lg text-gray-600" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-8" }
const _hoisted_10 = { class: "bg-white rounded-xl shadow-lg p-6 border-l-4 border-[#157813] hover:shadow-xl transition-shadow duration-300" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_13 = { class: "bg-[#157813]/10 p-3 rounded-full" }
const _hoisted_14 = { class: "bg-white rounded-xl shadow-lg p-6 border-l-4 border-gray-600 hover:shadow-xl transition-shadow duration-300" }
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_17 = { class: "bg-gray-600/10 p-3 rounded-full" }
const _hoisted_18 = { class: "bg-white rounded-xl shadow-lg p-6 border-l-4 border-green-600 hover:shadow-xl transition-shadow duration-300" }
const _hoisted_19 = { class: "flex items-center justify-between" }
const _hoisted_20 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_21 = { class: "bg-green-600/10 p-3 rounded-full" }
const _hoisted_22 = { class: "bg-white rounded-xl shadow-lg p-6 border-l-4 border-gray-700 hover:shadow-xl transition-shadow duration-300" }
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_25 = { class: "bg-gray-700/10 p-3 rounded-full" }
const _hoisted_26 = { class: "bg-white rounded-xl shadow-lg p-6 border-l-4 border-gray-800 hover:shadow-xl transition-shadow duration-300" }
const _hoisted_27 = { class: "flex items-center justify-between" }
const _hoisted_28 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_29 = { class: "bg-gray-800/10 p-3 rounded-full" }
const _hoisted_30 = {
  key: 0,
  class: "bg-white rounded-xl shadow-lg p-6 mb-8"
}
const _hoisted_31 = { class: "text-2xl font-bold text-gray-900 mb-6 flex items-center" }
const _hoisted_32 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_33 = {
  key: 0,
  class: "text-center"
}
const _hoisted_34 = { class: "bg-gradient-to-br from-[#157813] to-green-700 text-white rounded-lg p-4 mb-2" }
const _hoisted_35 = { class: "text-2xl font-bold" }
const _hoisted_36 = {
  key: 1,
  class: "text-center"
}
const _hoisted_37 = { class: "bg-gradient-to-br from-gray-700 to-gray-800 text-white rounded-lg p-4 mb-2" }
const _hoisted_38 = { class: "text-2xl font-bold" }
const _hoisted_39 = {
  key: 2,
  class: "text-center"
}
const _hoisted_40 = { class: "bg-gradient-to-br from-green-600 to-green-700 text-white rounded-lg p-4 mb-2" }
const _hoisted_41 = { class: "text-2xl font-bold" }
const _hoisted_42 = {
  key: 1,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-8"
}
const _hoisted_43 = {
  key: 0,
  class: "bg-white rounded-xl shadow-lg p-6"
}
const _hoisted_44 = { class: "text-xl font-bold text-gray-900 mb-4 flex items-center" }
const _hoisted_45 = { class: "space-y-3" }
const _hoisted_46 = { class: "flex items-center" }
const _hoisted_47 = { class: "font-medium text-gray-700 capitalize" }
const _hoisted_48 = { class: "font-bold text-gray-900" }
const _hoisted_49 = {
  key: 1,
  class: "bg-white rounded-xl shadow-lg p-6"
}
const _hoisted_50 = { class: "text-xl font-bold text-gray-900 mb-4 flex items-center" }
const _hoisted_51 = { class: "space-y-3" }
const _hoisted_52 = { class: "flex items-center" }
const _hoisted_53 = { class: "font-medium text-gray-700 capitalize" }
const _hoisted_54 = { class: "font-bold text-gray-900" }
const _hoisted_55 = {
  key: 2,
  class: "bg-white rounded-xl shadow-lg p-6"
}
const _hoisted_56 = { class: "text-xl font-bold text-gray-900 mb-4 flex items-center" }
const _hoisted_57 = { class: "space-y-3" }
const _hoisted_58 = { class: "flex items-center" }
const _hoisted_59 = { class: "font-medium text-gray-700 capitalize" }
const _hoisted_60 = { class: "font-bold text-gray-900" }
const _hoisted_61 = {
  key: 3,
  class: "bg-white rounded-xl shadow-lg p-6"
}
const _hoisted_62 = { class: "text-xl font-bold text-gray-900 mb-4 flex items-center" }
const _hoisted_63 = { class: "space-y-3" }
const _hoisted_64 = { class: "flex items-center" }
const _hoisted_65 = { class: "font-medium text-gray-700 capitalize" }
const _hoisted_66 = { class: "font-bold text-gray-900" }
const _hoisted_67 = {
  key: 4,
  class: "bg-white rounded-xl shadow-lg p-6"
}
const _hoisted_68 = { class: "text-xl font-bold text-gray-900 mb-4 flex items-center" }
const _hoisted_69 = { class: "space-y-3" }
const _hoisted_70 = { class: "flex items-center" }
const _hoisted_71 = { class: "font-medium text-gray-700 capitalize" }
const _hoisted_72 = { class: "font-bold text-gray-900" }
const _hoisted_73 = {
  key: 5,
  class: "bg-white rounded-xl shadow-lg p-6"
}
const _hoisted_74 = { class: "text-xl font-bold text-gray-900 mb-4 flex items-center" }
const _hoisted_75 = { class: "space-y-3" }
const _hoisted_76 = { class: "flex items-center" }
const _hoisted_77 = { class: "font-medium text-gray-700 capitalize" }
const _hoisted_78 = { class: "font-bold text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LucideMessageSquare = _resolveComponent("LucideMessageSquare")!
  const _component_LucideFilter = _resolveComponent("LucideFilter")!
  const _component_LucideGitBranch = _resolveComponent("LucideGitBranch")!
  const _component_LucideBrain = _resolveComponent("LucideBrain")!
  const _component_LucideUsers = _resolveComponent("LucideUsers")!
  const _component_LucideBarChart3 = _resolveComponent("LucideBarChart3")!
  const _component_LucidePieChart = _resolveComponent("LucidePieChart")!
  const _component_LucideSettings = _resolveComponent("LucideSettings")!
  const _component_LucideDatabase = _resolveComponent("LucideDatabase")!
  const _component_LucideActivity = _resolveComponent("LucideActivity")!
  const _component_LucidePill = _resolveComponent("LucidePill")!
  const _component_LucideGitCommit = _resolveComponent("LucideGitCommit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-[#157813] mx-auto mb-4" }),
            _createElementVNode("p", { class: "text-lg text-gray-600" }, "Loading dashboard data...")
          ], -1)
        ]))]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-red-500 mb-4" }, [
                _createElementVNode("svg", {
                  class: "w-12 h-12 mx-auto",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                  })
                ])
              ], -1)),
              _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-xl font-bold text-gray-900 mb-2" }, "Error Loading Data", -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.error), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(0))),
                class: "bg-[#157813] text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
              }, " Retry ")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-4xl font-bold text-gray-900 mb-2" }, "Analytics Dashboard", -1)),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.demoData.overall_stats.time_period), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600 uppercase tracking-wide" }, " Client Queries ", -1)),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.formatNumber(
                  _ctx.demoData.overall_stats.number_of_queries_from_the_client
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_LucideMessageSquare, { class: "w-8 h-8 text-[#157813]" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600 uppercase tracking-wide" }, " Unique Queries ", -1)),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.formatNumber(
                  _ctx.demoData.overall_stats.unique_queries_from_the_client
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_LucideFilter, { class: "w-8 h-8 text-gray-600" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600 uppercase tracking-wide" }, " Decomposed Queries ", -1)),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.formatNumber(
                  _ctx.demoData.overall_stats.number_of_decomposed_queries
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_LucideGitBranch, { class: "w-8 h-8 text-green-600" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600 uppercase tracking-wide" }, " Unique Neurons ", -1)),
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.formatNumber(_ctx.demoData.overall_stats.unique_neurons)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_LucideBrain, { class: "w-8 h-8 text-gray-700" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600 uppercase tracking-wide" }, " Unique Users ", -1)),
                    _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.formatNumber(_ctx.demoData.overall_stats.unique_users)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_LucideUsers, { class: "w-8 h-8 text-gray-800" })
                  ])
                ])
              ])
            ]),
            (_ctx.hasEnrichmentStats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("h2", _hoisted_31, [
                    _createVNode(_component_LucideBarChart3, { class: "w-6 h-6 text-[#157813] mr-2" }),
                    _cache[10] || (_cache[10] = _createTextVNode(" Enrichment Statistics ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    (_ctx.demoData.enrichment_stats.medication_enrichments > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.formatNumber(_ctx.demoData.enrichment_stats.medication_enrichments)), 1)
                          ]),
                          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, " Medication Enrichments ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.demoData.enrichment_stats.indication_enrichments > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.demoData.enrichment_stats.indication_enrichments), 1)
                          ]),
                          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, " Indication Enrichments ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.demoData.enrichment_stats.features > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.formatNumber(_ctx.demoData.enrichment_stats.features)), 1)
                          ]),
                          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Features", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasBreakdownSections)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  (_ctx.demoData.enrichment_breakdowns.analytics_type.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("h3", _hoisted_44, [
                          _createVNode(_component_LucidePieChart, { class: "w-5 h-5 text-[#157813] mr-2" }),
                          _cache[14] || (_cache[14] = _createTextVNode(" Analytics Type Distribution ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demoData.enrichment_breakdowns
              .analytics_type, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                            }, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`w-4 h-4 rounded-full mr-3 ${_ctx.getColorClass(
                  index,
                  'green'
                )}`)
                                }, null, 2),
                                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.formatLabel(item.value)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.formatNumber(item.cnt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.demoData.enrichment_breakdowns.business_rules.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("h3", _hoisted_50, [
                          _createVNode(_component_LucideSettings, { class: "w-5 h-5 text-gray-600 mr-2" }),
                          _cache[15] || (_cache[15] = _createTextVNode(" Business Rules Distribution ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demoData.enrichment_breakdowns
              .business_rules, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                            }, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`w-4 h-4 rounded-full mr-3 ${_ctx.getColorClass(
                  index,
                  'gray'
                )}`)
                                }, null, 2),
                                _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.formatLabel(item.value)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.formatNumber(item.cnt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.demoData.enrichment_breakdowns.features.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("h3", _hoisted_56, [
                          _createVNode(_component_LucideDatabase, { class: "w-5 h-5 text-green-600 mr-2" }),
                          _cache[16] || (_cache[16] = _createTextVNode(" Top Features ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demoData.enrichment_breakdowns.features.slice(0, 6), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                            }, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`w-4 h-4 rounded-full mr-3 ${_ctx.getColorClass(
                  index,
                  'green'
                )}`)
                                }, null, 2),
                                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.formatLabel(item.value)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.formatNumber(item.cnt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.demoData.enrichment_breakdowns.indication_enrichments.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("h3", _hoisted_62, [
                          _createVNode(_component_LucideActivity, { class: "w-5 h-5 text-gray-700 mr-2" }),
                          _cache[17] || (_cache[17] = _createTextVNode(" Medical Indications ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demoData.enrichment_breakdowns
              .indication_enrichments, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                            }, [
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`w-4 h-4 rounded-full mr-3 ${_ctx.getColorClass(
                  index,
                  'dark'
                )}`)
                                }, null, 2),
                                _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.formatLabel(item.value)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.formatNumber(item.cnt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.demoData.enrichment_breakdowns.medication_enrichments.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("h3", _hoisted_68, [
                          _createVNode(_component_LucidePill, { class: "w-5 h-5 text-[#157813] mr-2" }),
                          _cache[18] || (_cache[18] = _createTextVNode(" Top Medications ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demoData.enrichment_breakdowns
              .medication_enrichments, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                            }, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`w-4 h-4 rounded-full mr-3 ${_ctx.getColorClass(
                  index,
                  'green'
                )}`)
                                }, null, 2),
                                _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.formatLabel(item.value)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.formatNumber(item.cnt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.demoData.enrichment_breakdowns.project_step.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _createElementVNode("h3", _hoisted_74, [
                          _createVNode(_component_LucideGitCommit, { class: "w-5 h-5 text-gray-800 mr-2" }),
                          _cache[19] || (_cache[19] = _createTextVNode(" Project Steps ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demoData.enrichment_breakdowns.project_step, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                            }, [
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`w-4 h-4 rounded-full mr-3 ${_ctx.getColorClass(
                  index,
                  'dark'
                )}`)
                                }, null, 2),
                                _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.formatLabel(item.value)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.formatNumber(item.cnt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
  ]))
}